import React from 'react';
import { ArrowUp, ArrowDown } from 'lucide-react';

function KpiCard({ title, data }) {
  const { value, change } = data || { value: 0, change: 0 };
  const isPositive = change >= 0;
  const changeColor = change > 0 ? 'text-red-500' : 'text-green-500';

  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <h3 className="text-sm font-medium text-slate-500">{title}</h3>
      <div className="flex items-baseline justify-between mt-2">
        <p className="text-3xl font-bold text-slate-800">{value}</p>
        <div className={`flex items-center text-sm font-semibold ${changeColor}`}>
          {isPositive ? <ArrowUp size={16} /> : <ArrowDown size={16} />}
          <span>{Math.abs(change).toFixed(1)}%</span>
        </div>
      </div>
    </div>
  );
}

export default KpiCard;